import ObjectToURLUtil from "@/utils/urlUtils/ObjectToURLUtil.ts";
import Operator from "@/utils/constants/Operator.ts";
import DTOExperssion = namaTypes.DTOExperssion;
import DTOCriteria = namaTypes.DTOCriteria;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import {URLSerializer} from "@/utils/presenters/interfaces.ts";

const IN_VALUES: string = "inv";
const RIGHT_HAND_SIDE: string = "rhs";
const OPERATOR: string = "op";
const ID: string = "id";
const RELATIONSHIP: string = "rltn";
const VALUE: string = "vlu";
const SOURCE_CHART: string = "sch";
const LOCAL_TO_CHART: string = "lch";

export class CriteriaExpressionSerializer implements URLSerializer<DTOExperssion>{
  constructor() {

  }

  flattenIfNeeded(expressions?: DTOExperssion[]) {
    if (!expressions || !expressions.length)
      return expressions;
    return expressions.flatMap(e => this.flatten(e));
  }

  flatten(_this: DTOExperssion, p?: DTOExperssion) {
    if (_this.operator !== Operator.OpenBracket)
      return [_this];
    if (!_this.children || !_this.children.length)
      return [];
    let subExpressions: DTOExperssion[] = _this.children.flatMap(e => this.flatten(e, _this));
    if (!subExpressions || !subExpressions.length)
      return [];
    subExpressions.splice(0, 0, _this);
    let closeBracket: DTOExperssion = {operator: Operator.CloseBracket};
    closeBracket.relation = !p ? _this.relation : p.relation;
    subExpressions.push(closeBracket);
    return subExpressions;
  }

  toProperties(expression: DTOExperssion): Map<string, string> {
    let map: Map<string, string> = new Map();
    map.set(ID, expression.field ?? "");
    map.set(OPERATOR, expression.operator ?? "");
    map.set(RIGHT_HAND_SIDE, expression.rightHandSide ?? "");
    map.set(RELATIONSHIP, expression.relation ?? "");
    map.set(IN_VALUES, ObjectToURLUtil.listToString(expression.inValues ?? []));
    return map;
  }

  fromProperties(properties: Map<string, string>): DTOExperssion {
    let dtoExpression: DTOExperssion = {};
    dtoExpression.field = properties[ID];
    if (properties[OPERATOR])
      dtoExpression.operator = properties[OPERATOR];
    dtoExpression.rightHandSide = properties[RIGHT_HAND_SIDE];
    if (properties[RELATIONSHIP])
      dtoExpression.relation = properties[RELATIONSHIP];
    dtoExpression.inValues = ObjectToURLUtil.stringToList(properties[IN_VALUES]);
    return dtoExpression;
  }

  toURL(criteria?: DTOCriteria | null): string {
    if (!criteria)
      return "";
    return ObjectToURLUtil.toUrl(criteria.expressions, this);
  }

  criteriaFromURL(url?: string): DTOCriteria {
    let criteria: DTOCriteria = {};
    criteria.expressions = ObjectToURLUtil.fromURL(url, this);
    return criteria;
  }
}

export class QuestionFieldsSerializer implements URLSerializer<DTOFilledQuestionField>{
  constructor() {

  }

  flattenIfNeeded(questions?: DTOFilledQuestionField[]) {
    return questions;
  }

  toProperties(object: DTOFilledQuestionField): Map<string, string> {
    let map: Map<string, string> = new Map();
    map.set(ID, object.id ?? "");
    map.set(VALUE, object.value ?? "");
    map.set(SOURCE_CHART, object.sourceChart ?? "");
    map.set(LOCAL_TO_CHART, object.localToChart ?? "");
    return map;
  }

  fromProperties(properties: Map<string, string>): DTOFilledQuestionField {
    let filledQuestion: DTOFilledQuestionField = {};
    filledQuestion.id = properties[ID];
    filledQuestion.value = properties[VALUE];
    const src = properties[SOURCE_CHART];
    if (src)
      filledQuestion.sourceChart = src;
    const localToChart = properties[LOCAL_TO_CHART];
    if (localToChart)
      filledQuestion.localToChart = localToChart;
    return filledQuestion;
  }

  toURL(filledQuestionFields: DTOFilledQuestionField[]): string {
    return ObjectToURLUtil.toUrl(filledQuestionFields, this);
  }

  questionsFromURL(url: string | undefined): DTOFilledQuestionField[] {
    return ObjectToURLUtil.fromURL(url, this);
  }
}
